import React from 'react';
import useMedia from 'use-media';
import { Label } from '../atoms/label';


export const GolfFooterContainer = () => {

    const isWideTablet = useMedia({ maxWidth: '960px' });
    const isWidePhone = useMedia({ maxWidth: '480px' });

    return (
        <div>
            <Label label={"COPYRIGHT © RESORTTRUST ALL RIGHTS RESERVED"} style={isWideTablet ? styles.footerLabel2 : styles.footerLabel} />
        </div>
    )
};

const styles = {

    footerLabel: {
        width: "63%",
        margin: "0 auto",
        //marginTop: "50px",
        textAlign: "center",
    },
    footerLabel2: {
        width: "90%",
        margin: "0 auto",
        //marginTop: "50px",
        textAlign: "center",
        fontSize: "0.7em",
    },
};